import { ClientSchema } from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { JSONObject } from '@ametista-ai/api-schema/json/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { clientsKeys } from './keys';
import { ClientMutationResponse } from './useCreateClient';

export function useUpdateClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: Partial<ClientSchema> & { id: string }) => {
      return apiClient.patch<ApiResponse<ClientMutationResponse>>(
        `/v1/clients/${params.id}`,
        params as JSONObject
      );
    },
    onSuccess: (response) => {
      if (!response?.data) return;
      queryClient.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
